import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ForwardButton, BackButton, DisplayErrors } from "./Survey.jsx";
import axios from "axios";

import { constants } from '../../Helpers/Constants'
import { Trans } from 'react-i18next';
import i18n from '../../i18n.js';
import moment from 'moment';

class RoleSelection extends Component {
    constructor(props) {
        super(props);

        this.selectRole = this.selectRole.bind(this);
        this.submitRole = this.submitRole.bind(this);

        this.state = {
            options:[
                {name: "Journalist", id: constants.user_role.media_influencer},
                {name: "Social Media Influencer", id: constants.user_role.media_influencer},
                {name: "Media - Other", id: constants.user_role.media_influencer},
                {name: "Purchasing/Fleet Buyer", id: constants.user_role.fleet_buyer},
                {name: "Executive", id: constants.user_role.fleet_buyer},
                {name: "Fleet Company Representative", id: constants.user_role.fleet_buyer},
                {name: "Fleet - Other", id: constants.user_role.fleet_buyer},
            ],
            selection: null,
            role_id: null,
            error: false
        };
    }

    componentDidMount() {
        document.title = "Role Selection - FleetXPress"
        var self = this;

        axios.get('/ajax/checkRoleSelect')
        .then(function(response) {
            if (response?.data.language !== "English") {
                var language_code = 'fr';

                i18n.changeLanguage(language_code)
                moment.locale(language_code);
            }
        })
        .catch(function(error) {
            if(error.response?.data.error == "Survey Completed") {
                self.props.history.push("/" + error.response?.data.redirect);
            } else if (error.response?.data.error == "Role Selected") {
                self.props.history.push("/survey")
            }
        })
    }

    selectRole(role, id) {
        this.setState({
            selection: role,
            role_id: id,
            error: false
        })
    }

    submitRole() {
        var self = this;

        if (this.state.selection && this.state.role_id) {
            axios.post('/ajax/selectrole',{
                role_id: this.state.role_id,
                role_name: this.state.selection
            })
            .then((response) => {
                self.props.history.push('/survey')
            })
            .catch(function(error) {
                //
            })
        } else {
            this.setState({
                error: true
            })
        }
    }

    render() {
        return (
            <div className = "registration-container">
                <div className="registration-navbar">
                    <img src="images/dvms_logo.png" />
                </div>
            <div className = "validation-container">
                    <div className="registration-card validation-card">
                        <div className="survey-header">
                            <div className="survey-heading">
                                <Trans>Help us get to know you a little bit better</Trans>.
                            </div>
                            <div className="survey-question-subheading"><Trans>We want to provide you an experience that is tailored to your needs</Trans>.</div>
                            <div className="survey-question-help">
                                <Trans>Please select the role that best applies to you</Trans>.
                            </div>
                            <div className="survey-question-subtext">
                                <Trans>*You will not be able to change your selection once selected</Trans>.
                            </div>
                        </div>
                        <div className="registration-main" style={{flexWrap: "wrap"}}>
                            <div className={"role-selection-container" + (this.state.error ? " error" : "")}>
                                {
                                    this.state.options.map((option) => (
                                        <div className={"role-selection-option" + (this.state.selection === option.name ? " active" : "")} onClick={() => this.selectRole(option.name, option.id)}>
                                            <Trans>{option.name}</Trans>
                                            {this.state.selection === option.name && (<img src="/images/icons/survey/Checkmark_White.svg" className="active-checkmark"/>)}
                                        </div>
                                    ))
                                }
                            </div>
                            { this.state.error && <span style={{fontSize: "10px", color: "red", display: "ruby-text", textAlign: "left", margin: "0 auto", width: "65%"}}><Trans>* A selection is required</Trans></span>}
                        </div>
                        
                        <div className="registration-actions">
                            <div className="registration-left">
                            </div>
                            <div className="registration-right">
                                <span className={"primary medium registration-button" + (this.state.selection != null ? " registration-active" : "")} style={{marginLeft: "20px"}} onClick={(e) => this.submitRole()}>
                                    <span><Trans>Next</Trans></span>
                                    <i className="fas fa-arrow-right" style={{marginLeft: "40px"}}></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps,)(RoleSelection);